import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const values = [
  { icon: "ri-filter-3-line", title: "精选优先", desc: "不做大而全的堆砌，只挑真正值得一口气看完的高口碑短番，帮你在茫茫番海里省时间。" },
  { icon: "ri-magic-line", title: "贴近下饭", desc: "内容围绕泡面番、下饭番和日常搞笑短篇展开，追求轻松、解压、不占时间的追番体验。" },
  { icon: "ri-heart-line", title: "真诚安利", desc: "每部推荐都来自真实观感，编辑部亲测踩雷后再来安利，把快乐诚实地交到你手上。" },
];

const process = [
  { step: "01", title: "海量海选", desc: "追踪新番与口碑作品，建立短番候选池。" },
  { step: "02", title: "编辑试看", desc: "编辑部逐部试看，筛选出真正值得推荐的。" },
  { step: "03", title: "分类归档", desc: "按泡面番、短番、下饭番、治愈系等分类整理。" },
  { step: "04", title: "年度复盘", desc: "持续更新榜单与盘点，帮你随时找到好番。" },
];

export default function About() {
  return (
    <>
      <Navbar />
      <main>
        <section className="relative overflow-hidden pt-24 md:pt-28">
          <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16 text-center">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-800">
              <i className="ri-bubble-chart-line" aria-hidden="true" />
              关于我们
            </span>
            <h1 className="mx-auto mt-5 max-w-3xl font-heading text-3xl leading-tight text-foreground-950 md:text-5xl">
              让小水看番，成为你的下饭搭子
            </h1>
            <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-foreground-600">
              我们是一群爱看泡面番、爱刷日常搞笑短篇的普通观众。因为总在茫茫番海里找番找到怀疑人生，
              所以决定自己做一座「短番精选库」，把每部下饭神番都替你试过，再放心地安利给你。
            </p>
          </div>
        </section>

        <section className="mx-auto w-full max-w-7xl px-4 md:px-6 pb-14 md:pb-20">
          <div className="grid gap-6 md:grid-cols-3">
            {values.map((v) => (
              <div key={v.title} className="rounded-2xl border border-background-200/70 bg-background-100 p-6">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-2xl text-primary-700">
                  <i className={v.icon} aria-hidden="true" />
                </span>
                <h2 className="mt-4 font-heading text-xl text-foreground-950">{v.title}</h2>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-background-100/70">
          <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
            <div className="text-center">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">我们是怎么挑番的</h2>
              <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
                一套透明、用心的流程，保证每一部进入小水看番的短番都经得起一口气看完的考验。
              </p>
            </div>
            <div className="mt-10 grid gap-6 md:grid-cols-4">
              {process.map((p) => (
                <div key={p.step} className="relative rounded-2xl bg-background-50 p-6">
                  <span className="font-heading text-4xl text-accent-400">{p.step}</span>
                  <h3 className="mt-3 font-heading text-lg text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
          <div className="grid items-center gap-10 md:grid-cols-2">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">和我们一起把快乐刷完</h2>
              <p className="mt-4 text-sm leading-7 text-foreground-600">
                小水看番会持续更新短番推荐、下饭安利和年度盘点。如果你也爱看泡面番和日常搞笑短篇，
                欢迎常来逛逛，或者在番剧库里找到你的下一部下饭神番。
              </p>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/library"
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
                >
                  <i className="ri-movie-2-line" aria-hidden="true" />
                  去番剧库逛逛
                </Link>
                <Link
                  to="/faq"
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-background-100 px-6 py-3 text-sm font-medium text-foreground-800 whitespace-nowrap transition-colors hover:bg-background-200"
                >
                  查看常见问题
                </Link>
              </div>
            </div>
            <div className="overflow-hidden rounded-3xl">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20anime%20style%20flat%20illustration%20of%20a%20small%20friendly%20team%20of%20young%20people%20gathered%20around%20a%20laptop%20watching%20anime%20and%20laughing%2C%20coral%20orange%20and%20cream%20palette%2C%20clean%20minimal%20background%2C%20cozy%20cheerful%20youthful%20mood&width=1200&height=900&seq=about-team-01&orientation=landscape"
                alt="小水看番编辑部一起挑选下饭短番"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}